import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TabsModule} from '../../components/tabs/tabs.module';
import {CommonComponentsModule} from '../../common-components.module';

import {DatetimeModule} from '../../components/datetime/datetime.module';
import {AngularMaterialImportModule} from '../../components/angular-material-import-module/angular-material-import.module';
import {AmenitiesService} from '../../services/amenities.service';
import {AmenitiesComponent} from './amenities.component';
import {AmenitiesListComponent} from './amenities-list/amenities-list.component';
import {AmenitiesFilterComponent} from '../../components/amenities-filter/amenities-filter.component';
import {AmenitiesModalComponent} from './amenities-modal/amenities-modal.component';
import {AmenitiesViewComponent} from './amenities-view/amenities-view.component';
import {AmenitiesCalendarViewComponent} from './amenities-calendar-view/amenities-calendar-view.component';
import {FieldsModule} from '../../components/fields/fields.module';
import {AmenitiesPaymentComponent} from './amenity-payment/amenities-payment.component';
import {SafeHtmlPipeModule} from '../../pipes/safe-html/safe-html-pipe.module';
import {StripePaymentModule} from '../../components/stripe-payment/stripe-payment.module';
import {AmenityDepositChargeComponent} from './amenity-deposit-charge/amenity-deposit-charge.component';
import {AmenitiesPaymentsComponent} from './amenities-payments/amenities-payments.component';
import {AmenitiesInfoComponent} from './amenity-info/amenities-info.component';
import {AmenitiesDetailedViewComponent} from './amenities-detailed-view/amenities-detailed-view.component';
import {AmenitiesQuotesModalComponent} from './amenity-quotes-modal/amenities-quotes-modal.component';
import {AmenityPaymentModalComponent} from './amenity-payment-modal/amenity-payment-modal.component';
import { DisabledDateModalComponent } from './disabled-date-modal/disabled-date-modal.component';
import {UtilsModule} from '../../modules/utils/utils.module';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        FieldsModule,
        AngularMaterialImportModule,
        SafeHtmlPipeModule,
        StripePaymentModule,
        UtilsModule
    ],
    declarations: [
        AmenitiesComponent,
        AmenitiesListComponent,
        AmenitiesFilterComponent,
        AmenitiesModalComponent,
        AmenitiesViewComponent,
        AmenitiesInfoComponent,
        AmenitiesPaymentsComponent,
        AmenitiesCalendarViewComponent,
        AmenitiesPaymentComponent,
        AmenityDepositChargeComponent,
        AmenitiesDetailedViewComponent,
        AmenitiesQuotesModalComponent,
        AmenityPaymentModalComponent,
        DisabledDateModalComponent
    ],
    exports: [
        AmenitiesModalComponent,
        AmenitiesQuotesModalComponent
    ],
    providers: [
        AmenitiesService
    ]
})
export class AmenitiesModule {
}




// WEBPACK FOOTER //
// /app/src/app/views/amenities/amenities.module.ts